var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgReadEmail = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.28635 0.590124C8.11466 0.47017 7.88639 0.46994 7.71446 0.589547L1.04446 5.22955C0.897384 5.33186 0.822189 5.49896 0.830578 5.66562C0.830187 5.67368 0.82999 5.68179 0.82999 5.68992V13.6899H0.829865L0.830115 13.7011C0.840817 14.1796 1.03751 14.635 1.37847 14.9709C1.71943 15.3067 2.17782 15.4965 2.65638 15.4999L2.65638 15.4999H2.65999H13.33C13.8156 15.4999 14.2815 15.308 14.6262 14.9659C14.9709 14.6238 15.1664 14.1593 15.17 13.6737H15.17V13.6699V5.66992C15.17 5.6691 15.17 5.66828 15.17 5.66746C15.1722 5.50725 15.0976 5.3488 14.9563 5.25012L8.28635 0.590124ZM13.8059 5.66626L7.99937 1.60951L2.16788 5.6662L7.99938 9.74912L13.8059 5.66626ZM8.28758 10.7689L14.17 6.63273V13.6679C14.1679 13.889 14.0787 14.1003 13.9218 14.2561C13.7644 14.4123 13.5517 14.4999 13.33 14.4999H2.66196C2.44408 14.4979 2.23547 14.4113 2.0802 14.2584C1.92572 14.1063 1.83611 13.9003 1.82999 13.6837V6.65037L7.71322 10.7695C7.8857 10.8903 8.11535 10.89 8.28758 10.7689Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReadEmail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/readEmail.ee480c99.svg";
export { ForwardRef as ReactComponent };